import { render, staticRenderFns } from "./UdfRuntime.vue?vue&type=template&id=b87a4caa&shadow"
import script from "./UdfRuntime.vue?vue&type=script&lang=js&shadow"
export * from "./UdfRuntime.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./UdfRuntime.vue?vue&type=style&index=0&id=b87a4caa&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports